// src/components/Events/AICIC2025.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Events.css';

const AICIC2025 = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    // Open external site in new tab after 2 seconds
    const timer = setTimeout(() => {
      window.open('https://aicisnigeria.abvig.org/', '_blank');
    }, 2000);

    // Countdown timer
    const countdownTimer = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    return () => {
      clearTimeout(timer);
      clearInterval(countdownTimer);
    };
  }, []);

  return (
    <div className="events-page" style={{ paddingTop: '80px' }}>
      <div className="events-hero" style={{ minHeight: '60vh' }}>
        <div style={{ maxWidth: '600px', margin: '0 auto' }}>
          <h1 style={{ fontSize: '28px', marginBottom: '20px' }}>
            AICIS 2025 Post Summit Workshop
          </h1>
          
          <div style={{ 
            fontSize: '48px', 
            color: '#d4af37',
            marginBottom: '20px'
          }}>
            {countdown > 0 ? countdown : 'Opening...'}
          </div>
          
          <p style={{ fontSize: '16px', opacity: 0.8, marginBottom: '30px' }}>
            {countdown > 0 
              ? `Redirecting in ${countdown} seconds...` 
              : 'Opening workshop page...'}
          </p>
          
          {/* Back Button */}
          <button 
            onClick={() => navigate(-1)}
            style={{
              background: 'rgba(255,255,255,0.1)',
              border: '1px solid rgba(255,255,255,0.2)',
              color: 'white',
              padding: '12px 30px',
              borderRadius: '50px',
              fontSize: '14px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              marginRight: '10px'
            }}
            onMouseEnter={(e) => {
              e.target.style.background = 'rgba(255,255,255,0.2)';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = 'rgba(255,255,255,0.1)';
            }}
          >
            ← Go Back
          </button>

          {/* External Link Button */}
          <a 
            href="https://aicisnigeria.abvig.org/" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{
              display: 'inline-block',
              background: '#d4af37',
              color: '#0d3d25',
              padding: '12px 30px',
              borderRadius: '50px',
              fontSize: '14px',
              fontWeight: '700',
              textDecoration: 'none',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.background = '#e8c84a';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = '#d4af37';
            }}
          >
            Open Workshop Page →
          </a>
        </div>
      </div>
    </div>
  );
};

export default AICIC2025;